import React, { FC } from 'react';
import cx from 'classnames';

// components
import { RichTextRenderer } from 'src/components/RichTextRenderer';

import { FormSectionDisclaimerProps } from './FormSectionDisclaimer.types';

const FormSectionDisclaimer: FC<FormSectionDisclaimerProps> = ({
  formData,
  cmsProps,
  className,
}) => {
  const disclaimerClassName = cx('contact-form__disclaimer', className);
  if (cmsProps.formData.disclaimer) {
    if (typeof cmsProps.formData.disclaimer === 'string') {
      return (
        <p
          className={disclaimerClassName}
          dangerouslySetInnerHTML={{
            __html: cmsProps.formData.disclaimer,
          }}
        />
      );
    } else {
      return (
        <RichTextRenderer
          className={disclaimerClassName}
          content={cmsProps.formData.disclaimer}
        />
      );
    }
  } else {
    return (
      <p
        data-testid='disclaimer'
        className={disclaimerClassName}
        dangerouslySetInnerHTML={{
          __html: formData.disclaimer,
        }}
      />
    );
  }
};

export default FormSectionDisclaimer;
